import React, { useRef, useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  IconButton,
  Popover,
  StyledEngineProvider,
  Typography,
} from "@mui/material";
// import { Add, Apps, Remove } from "@mui/icons-material";
import Marquee from "react-fast-marquee";
import { NewsInstance } from "../services/shared_news";

const NewsMarquee = ({ height }) => {
  const fontSize = height * 0.5;
  const [pendingNews, setPendingNews] = useState([]);

  useEffect(() => {
    (async () => {
      const newsItems = await NewsInstance.newsItems;
      setPendingNews(
        newsItems?.pendingNews?.length > 0
          ? newsItems?.pendingNews
          : [{ title: "正在連接新聞資訊" }]
      );
    })();
  }, []);

  useEffect(() => {
    console.log("pendingNews");
    console.log(pendingNews);
  }, [pendingNews]);

  return (
    <Box sx={{ backgroundColor: "#2E3B55", height: height }}>
      <Marquee key={pendingNews.length} pauseOnClick style={{ height: "100%" }}>
        {pendingNews.map((_pendingNews, index) => (
          <Box key={`marquee-child-${index}`}>
            <Typography
              sx={{ fontSize, color: "white" }}
            >{`${_pendingNews.title}`}</Typography>
            <Typography> {"   "}</Typography>
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};
const f = () => {};

export { NewsMarquee, f };
